import { Injectable } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { CaseHistoryRecord } from '../../_models/incident/wfdssCase/incident-logs/caseHistoryRecord';
import { WfdssCase } from '../../_models/incident/wfdssCase/wfdssCase';
import { UnixToCentralTimePipe } from 'src/app/_helpers/pipes/unix-to-central-date.pipe';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class ExportService {

  constructor() { }

  exportIncidentHistory(history: CaseHistoryRecord[], wfdssCase: WfdssCase) {
    const caseHistoryRecords = history.map(record => new CaseHistoryRecord(record));
    const replacer = (key, value) => value === null ? '' : value;
    const fieldNames = ['createdDateTime', 'performedByUser', 'action', 'details'];
    const headers = ['Date', 'User', 'Action', 'Details'];

    const csv = caseHistoryRecords.map(row => fieldNames.map(fieldName => {
      return JSON.stringify(row[fieldName], replacer);
    }).join(','));

    csv.unshift(headers.join(','));

    const csvArray = csv.join('\r\n');
    const dummyElement = document.createElement('a');
    const blob = new Blob([csvArray], {type: 'text/csv'});
    const url = window.URL.createObjectURL(blob);

    dummyElement.href = url;

    const timestamp = new Date();
    const month  = timestamp.getMonth() + 1 < 10 ? '0' + (timestamp.getMonth() + 1) : (timestamp.getMonth() + 1);
    const day = timestamp.getDate() < 10 ? '0' + timestamp.getDate() : timestamp.getDate();

    dummyElement.download = `${wfdssCase.name}_${[month, day, timestamp.getFullYear()].join('')}_IncidentHistory.csv`;
    dummyElement.click();
    window.URL.revokeObjectURL(url);
    dummyElement.remove();
  }
  /**
   * @description Takes a MatTableDataSource object and declaratively generates a csv. Property access is based on sortingDataAccessor function
   */
  exportTableData<T>(tableData: MatTableDataSource<T>, columnDefs: string[], headerArray:string[], namePrefix: string, nameSuffix: string){
    // Why the page size logic?: To acquire data, we use connect(). connect() returns the table values verbatim including sort, filter, and PAGINATION logic.
    // By default, connect() will only return data within the current page. By temporarily setting the page size to the legnth of all filtered data, the whole filtered data source is captured in the export. After export, we reset the page size so the user doesn't see any difference(since tableData is pass by reference).
    const initialPageSize = tableData.paginator.pageSize
    const filteredDataLength = tableData.filteredData.length
    const centralTimePipe = new UnixToCentralTimePipe();

    tableData.paginator._changePageSize(filteredDataLength)
    tableData.paginator.pageSize = filteredDataLength
    const stringArray =
    tableData.connect().value.map((row: any) => {
      return  columnDefs.map((colDef) => {
        if(colDef==='unwatchIncident') return;
        let value = JSON.stringify(tableData.sortingDataAccessor(row, colDef));
        //value = value?.replace(/"/g, '')?.replace(/\\/g,'')
        if(!value || (value === '""')) value = 'N/A'
        switch(colDef) {
          case 'strategy':
            if(value === '"undefined, undefined, undefined, undefined, undefined, undefined"') value = 'N/A';
            break;
          case 'publishedDecision':
            value = row.publishedDecision ? centralTimePipe.transform(row.publishedDecision) : 'N/A';
            break;
          case 'assessmentDue':
           if (row.isStrategyMet === true) {
            value = 'Strategy Has Been Met';
           } else if(row.isStrategyMet === false && row.assessmentDue) {
              const assessmentDueDate = new Date(row.assessmentDue);
              const month  = assessmentDueDate.getMonth() + 1 < 10 ? '0' + (assessmentDueDate.getMonth() + 1) : (assessmentDueDate.getMonth() + 1);
              const day = assessmentDueDate.getDate() < 10 ? '0' + assessmentDueDate.getDate() : assessmentDueDate.getDate();
              const year = assessmentDueDate.getFullYear();
              value = `${month}/${day}/${year}`;
            } else {
              value = 'N/A';
            }           
            break;
          case 'Created Date/Time(CT)' : // Used for export
            let createdDate;
            if(row?.createdDate) {
              const createdDatTime = new UnixToCentralTimePipe().transform(row?.createdDate);
              createdDate = moment(createdDatTime).format('MM/DD/YYYY');
            }
            value = createdDate;
            break;
        }

        return value
      }).join(',')
    })
    tableData.paginator._changePageSize(initialPageSize)
    tableData.paginator.pageSize = initialPageSize
    stringArray.unshift(headerArray.join(','))
    const stringifiedCSV = stringArray.join('\r\n')
    this.nameAndDownloadCSV(stringifiedCSV, namePrefix, nameSuffix)
  }
  /**
   * @description Takes a data array and exports a csv. Property values will be directly inserted into cells, so make sure they are human readable 
   * @param data the array to convert to csv
   * @param namePrefix will be appended to the front of the CSV filename
   * @param nameSuffix will be appended to the end of the CSV filename
   * @param columnNameArray optional array of CSV column names at the top of the CSV. If ommited, the keys of the first element in the data array will be used instead.*/
  exportArray<T>(data: Array<T>, namePrefix: string, nameSuffix: string, columnNameArray?:string[],){
    let headers = Object.keys(data[0])
    let dataStringArray = data.map((row)=>{
      return headers.map((header)=>{
        return JSON.stringify(row[header])
      }).join(',')
    })
    !columnNameArray ? dataStringArray.unshift(headers.join(',')) : dataStringArray.unshift(columnNameArray.join(','))
    let csvString = dataStringArray.join('\r\n')
    this.nameAndDownloadCSV(csvString, namePrefix, nameSuffix)
  }


  private nameAndDownloadCSV(stringifiedCSV: string, namePrefix: string, nameSuffix: string){
    const dummyElement = document.createElement('a');
    const blob = new Blob([stringifiedCSV], {type: 'text/csv'});
    const url = window.URL.createObjectURL(blob);

    dummyElement.href = url;

    const timestamp = new Date();
    const month  = timestamp.getMonth() + 1 < 10 ? '0' + (timestamp.getMonth() + 1) : (timestamp.getMonth() + 1);
    const day = timestamp.getDate() < 10 ? '0' + timestamp.getDate() : timestamp.getDate();

    dummyElement.download = `${namePrefix}_${[month, day, timestamp.getFullYear()].join('')}${nameSuffix}.csv`;
    dummyElement.click();
    window.URL.revokeObjectURL(url);
    dummyElement.remove();
  }
}
